import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { UserDao } from '@app/dao/user/user.dao';
import { DomSanitizer } from '@angular/platform-browser';
interface DialogData {
  signatureUrl: string;
}

@Component({
    selector: 'pdf-modal',
    templateUrl: './pdf-modal.component.html',
    styleUrls: ['./pdf-modal.component.scss'],
    standalone: false
})
export class PdfModalComponent implements OnInit {
  @ViewChild('list', { static: true }) list: MatSelectionList;
  safeUrl;
  constructor(
    public dialogRef: MatDialogRef<PdfModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public userDao: UserDao,

    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.data.signatureUrl,
    );
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
